import {useState} from "react";
import {Send} from "lucide-react";
import {FormModal} from "@/components/UI";
import {apiPost} from "@/lib/api";

export default function RequestModal({close, notify, setModal, user}) {
  const [f, setF] = useState({category: "Personal shopping", destination: "", timeline: "Within 2 weeks", details: "", budget: ""});
  const ch = e => setF({...f, [e.target.name]: e.target.value});
  const submit = async (e) => {
    e.preventDefault();
    try {
      await apiPost("/requests", f);
      notify("Your request is with our India desk");
      close();
    } catch {
      sessionStorage.setItem("pending_rfq", JSON.stringify(f));
      close(); setModal("auth");
      notify("Sign in to send your request");
    }
  };
  return (
    <FormModal title="Tell us what you need." eyebrow="CONCIERGE REQUEST" close={close} testId="request-modal">
      <p className="modal-sub">The more you share, the more thoughtfully we can help.</p>
      <form onSubmit={submit}>
        <label>What can we help with?
          <select data-testid="request-category" name="category" value={f.category} onChange={ch}>
            <option>Personal shopping</option>
            <option>Travel &amp; stays</option>
            <option>Private event</option>
            <option>Home &amp; relocation</option>
            <option>Food &amp; dining</option>
            <option>Something else</option>
          </select>
        </label>
        <label>Where is it for?
          <input data-testid="request-destination" required name="destination" value={f.destination} onChange={ch} placeholder="City or country"/>
        </label>
        <label>Timeline
          <select data-testid="request-timeline" name="timeline" value={f.timeline} onChange={ch}>
            <option>Within 2 weeks</option><option>This month</option><option>Next 3 months</option><option>No rush</option>
          </select>
        </label>
        <label>Tell us a little more
          <textarea data-testid="request-details" required name="details" value={f.details} onChange={ch} placeholder="A few details help us get started..."/>
        </label>
        <label>Budget (optional)
          <input data-testid="request-budget" name="budget" value={f.budget} onChange={ch} placeholder="A rough number helps"/>
        </label>
        <button data-testid="request-submit" className="coral-button full" type="submit">Send request <Send size={16}/></button>
      </form>
    </FormModal>
  );
}
